export default function CustomProviderIcon() {
  return (
    <svg viewBox='0 0 24 24' className='w-6 h-6' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='24' height='24' rx='4' fill='#6B7280' />
      <path d='M12 6V12L16 14' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
      <circle cx='12' cy='12' r='6' stroke='white' stroke-width='1.5' />
    </svg>
  );
}
